import React, { SVGProps } from "react";

export const PersonIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 24 24" width={20} height={20} {...props}>
    <path stroke="currentColor" strokeWidth="2" d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx={12} cy={7} r={4} stroke="currentColor" strokeWidth="2" />
  </svg>
);

export default PersonIcon;
